import { initConsoleOverride } from 'utils';
import ReactDOM from 'react-dom';
import { App } from 'app/App';

import 'styles/global-styles.scss';

initConsoleOverride();

document.addEventListener('DOMContentLoaded', () => {

    const root = document.getElementById('root');

    if (root) {

        ReactDOM.render(<App />, root);

    }

});
